import { track } from '@betterment/js-runtime';
import $ from 'jquery';

$(document).on('click', '[data-track-event]', e => {
  var data = $(e.currentTarget).data();
  if (!data) {
    return;
  }

  handleSegmentEvent(data);
});

function handleSegmentEvent(data: any) {
  var eventProps = getEventProperties(data);
  if (eventProps) {
    track(eventProps.eventName, eventProps.props);
  }
}

function getEventProperties(data: any) {
  const eventName = data.trackEvent;
  const props = {
    name: data.trackName,
    flow: data.trackFlow,
    module: data.trackModule,
    application: 'BettermentForBusiness',
    client: 'Web',
  };

  if (
    (eventName === 'ElementClicked' || eventName === 'ElementViewed') &&
    props.application &&
    props.name &&
    props.client
  ) {
    return {
      eventName,
      props,
    };
  }

  return undefined;
}
